import { InjuryStatus } from '../news/news'

export enum InjuryStatusAbbreviation {
  ACTIVE = 'ACTIVE',
  PROBABLE = 'PROB',
  DOUBTFUL = 'DOUBT',
  QUESTIONABLE = 'QUEST',
  OUT = 'OUT',
  INACTIVE = 'INACTIVE',
  IR = 'IR',
  PUP = 'PUP',
  NFI = 'NFI',
  SUSPENDED = 'SUSP',
}

export const InjuryBodyPartAbbreviationMap = {
  Hamstring: 'HAM',
  Ankle: 'ANKLE',
  Groin: 'GROIN',
  Calf: 'CALF',
  Knee: 'KNEE',
  Shoulder: 'SHOULDER',
  Back: 'BACK',
  'Toe (Turf Toe)': 'TOE',
  Concussion: 'CON',
  Ribs: 'RIB',
  Finger: 'FNG',
  Illness: 'ILL',
  Quad: 'QUAD',
  Neck: 'NECK',
  Hip: 'HIP',
  Elbow: 'ELB',
  Wrist: 'WRIST',
  Hand: 'HAND',
  'Abdomen/Core': 'ABD',
  Stinger: 'STING',
  Foot: 'FOOT',
}

export const InjuryStatusAbbreviationMap = {
  [InjuryStatus.Active]: InjuryStatusAbbreviation.ACTIVE,
  [InjuryStatus.Probable]: InjuryStatusAbbreviation.PROBABLE,
  [InjuryStatus.Doubtful]: InjuryStatusAbbreviation.DOUBTFUL,
  [InjuryStatus.Questionable]: InjuryStatusAbbreviation.QUESTIONABLE,
  [InjuryStatus.Out]: InjuryStatusAbbreviation.OUT,
}

export const LIST_OF_INJURED_PLAYER_STATUS = [
  InjuryStatusAbbreviation.DOUBTFUL,
  InjuryStatusAbbreviation.OUT,
  InjuryStatusAbbreviation.PROBABLE,
  InjuryStatusAbbreviation.QUESTIONABLE,
  InjuryStatusAbbreviation.SUSPENDED,
]
